<template>
  <g fill-rule="evenodd">
    <path
      d="M1083.08 20.884c.358-.506.536-1.042.536-1.608 0-.981-.373-1.755-1.116-2.32-.715-.536-1.637-.805-2.768-.805-.834 0-1.533.195-2.099.581-.833.565-1.25 1.578-1.25 3.036h2.188c0-.625.06-1.027.179-1.206.267-.446.654-.669 1.16-.669.507 0 .878.163 1.117.491.237.327.357.67.357 1.027 0 .238-.12.535-.357.893-.06.118-.209.267-.447.446-.773.446-1.294.893-1.563 1.339-.238.387-.386.997-.446 1.83 0 .12.06.18.179.18h1.74c.15 0 .224-.06.224-.18 0-.327.03-.61.09-.848.088-.267.268-.52.535-.759l.625-.401c.566-.417.938-.76 1.116-1.027m-2.188 5.714c.03-.387-.081-.714-.335-.982-.252-.268-.572-.402-.959-.402-.357 0-.67.12-.937.357-.269.239-.403.551-.403.938 0 .387.12.707.358.96s.536.38.892.38c.388 0 .715-.113.983-.335.267-.224.401-.528.401-.916m-7.99-11.652c1.964-1.964 4.33-2.946 7.098-2.946 2.767 0 5.126.975 7.076 2.924 1.949 1.95 2.924 4.308 2.924 7.076s-.975 5.126-2.924 7.076c-1.95 1.949-4.309 2.924-7.076 2.924-2.768 0-5.127-.975-7.077-2.924-1.949-1.95-2.923-4.308-2.923-7.076s.967-5.12 2.902-7.054"
      transform="translate(-1111 -32) translate(41 20)"
    />
  </g>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "QuestionMarkIcon",
});
</script>
